/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function PlusMinusIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M21 6.476v7.381h7.5c.813 0 1.5.677 1.5 1.476 0 .861-.687 1.476-1.5 1.476H21v7.381c0 .862-.687 1.477-1.5 1.477-.875 0-1.5-.615-1.5-1.477v-7.38h-7.5c-.875 0-1.5-.616-1.5-1.477 0-.8.625-1.476 1.5-1.476H18v-7.38c0-.8.625-1.477 1.5-1.477.813 0 1.5.677 1.5 1.476M8 34.524c0-.8.625-1.476 1.5-1.476h20c.813 0 1.5.676 1.5 1.476 0 .86-.687 1.476-1.5 1.476h-20c-.875 0-1.5-.615-1.5-1.476"/>}
        </IconWrapper>);
}
